module.exports = {"baseUrl":"https://www.i2oc.com","downloadButton":{"enable":false,"postgresUrl":null,"i2ocApplicationUrl":null}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 204
// module chunks = 1